import ReactMarkdown from 'react-markdown';

const Strong = ({ children }: { children: React.ReactNode }) => {
  return <strong className="fw-bold">{children}</strong>;
};

const Emphasis = ({ children }: { children: React.ReactNode }) => {
  return <em className="fs-italic">{children}</em>;
};

export const QuestionnaireMarkdown = ({ children }: { children: string }) => {
  return (
    <ReactMarkdown
      components={{
        p: 'span',
        strong: Strong,
        em: Emphasis,
      }}
    >
      {children}
    </ReactMarkdown>
  );
};
